export class InvoiceCurrency {
	public iso: string
	public relation: number

	constructor(data: { iso: string; relation: number }) {
		this.iso = data.iso
		this.relation = data.relation
	}

	static create(data: Partial<InvoiceCurrency>): InvoiceCurrency {
		const defaultData: InvoiceCurrency = {
			iso: '',
			relation: 0,
		}

		return new InvoiceCurrency({ ...defaultData, ...data })
	}
}
